import { render } from "./CreateProjectUsersPage.vue?vue&type=template&id=385e037c"
import script from "./CreateProjectUsersPage.vue?vue&type=script&lang=js"
export * from "./CreateProjectUsersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__